import { FontColorEnum, FontSizeEnum, Typography } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { CataloguePicker } from '@/hooks/use-catalogue-picker';

/**
 * RISK: `Select` fires `onEndReached` only once the distance left to the bottom is at most this.
 * At 0, a fractional `scrollTop` (HiDPI screens, browser zoom) never gets there and no further
 * page is ever requested.
 */
const END_REACHED_THRESHOLD_PX = 48;

/** The props that turn a `Select` or a `SelectForm` into a paged, server-searched picker. */
export function useCatalogueSelectProps<TEntry>(picker: CataloguePicker<TEntry>) {
  const { t } = useTranslation();

  return {
    options: picker.options,
    withFilter: true,
    disableLocalFiltering: true,
    onFilterTextChange: picker.onSearch,
    onOpen: picker.onOpen,
    onEndReached: picker.onEndReached,
    onEndReachedThreshold: END_REACHED_THRESHOLD_PX,
    isLoadingMore: picker.isLoadingMore,
    // Without it `Select` says "Sin resultados" while the first page is still on its way.
    emptyState: picker.isLoadingFirstPage ? (
      <Typography fontSize={FontSizeEnum.Sm} color={FontColorEnum.Medium}>
        {t('Cargando...')}
      </Typography>
    ) : undefined,
  };
}
